<template>
  <div class="ly_appSize un_phoneView_wrapper __bgWhite hp_posiRel hp_mH_vh">
    <!-- 모달 (바텀시트) .__show 추가시 오픈 -->
    <article
      class="bl_modal_wrapper __bottomSheet __show"
      v-show="downloadModalShown"
      @click.stop="downloadModalShown = false"
    >
      <div class="bl_modal_dimed"></div>
      <!-- only Mobile -->
      <div class="bl_modal __onlyMobile" @click.stop="null">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <img src="/images/oeApp.svg" v-auto-title alt="오이 로고 이미지" />
            <h2>앱에서 더 구경할 수 있어요<br />앱에서 볼까요?</h2>
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <a class="el_btn" target="_blank" :href="storeLink">앱으로 보기</a>
          <button
            class="el_btn __light"
            @click.stop="downloadModalShown = false"
          >
            닫기
          </button>
        </section>
      </div>
      <!-- only PC -->
      <div class="bl_modal __onlyPC" @click.stop="null">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <QRCode :value="storeLink"></QRCode>
            <h2>앱에서 더 구경할 수 있어요</h2>
            <span
              >스마트폰 카메라로 QR코드를 비추면<br />다운로드 페이지로
              연결돼요</span
            >
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <button
            class="el_btn __light"
            @click.stop="downloadModalShown = false"
          >
            닫기
          </button>
        </section>
      </div>
    </article>

    <h1 class="blind">
      {{
        feed.description?.length > 0
          ? truncateString(feed.description, 35)
          : feed.gatheringInfo.title
      }}
    </h1>

    <!-- 모달 (바텀시트) .__show 추가시 오픈 -->
    <article class="bl_modal_wrapper __bottomSheet">
      <div class="bl_modal_dimed"></div>
      <!-- only Mobile -->
      <div class="bl_modal __onlyMobile">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <img src="/images/oeApp.svg" v-auto-title alt="오이 로고 이미지" />
            <h2>앱에서 더 구경할 수 있어요<br />앱에서 볼까요?</h2>
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <a class="el_btn" target="_blank" :href="storeLink">앱으로 보기</a>
          <button class="el_btn __light">닫기</button>
        </section>
      </div>
      <!-- only PC -->
      <div class="bl_modal __onlyPC">
        <section class="bl_modal_body __pb24">
          <div class="bl_modal_cont">
            <QRCode :value="storeLink"></QRCode>
            <h2>앱에서 더 구경할 수 있어요</h2>
            <span
              >스마트폰 카메라로 QR코드를 비추면<br />다운로드 페이지로
              연결돼요</span
            >
          </div>
        </section>
        <section class="bl_modal_btnWrapper">
          <button class="el_btn __light">닫기</button>
        </section>
      </div>
    </article>

    <!-- 탑 바 -->
    <header class="bl_topBar">
      <a class="bl_topBar_logo" @click="goTo('/')"></a>
      <ul class="bl_topBar_nav">
        <!-- <li><a href="introduceOE.html">앱 소개</a></li> -->
        <!-- <li><a href="">취미 모임</a></li> -->
        <!-- <li><a href="">소통 공간</a></li> -->
      </ul>
    </header>

    <section class="un_feedList_item __detailVer">
      <div class="un_feedList_desc">
        <figure class="el_profile hp_mb12">
          <!-- <img
            :src="feed.author.getImage"
            v-auto-title alt="유저 프로필"
            @click="downloadModalShown = true"
          /> -->
          <CustomProfileImage
            :src="feed.author.image"
            v-auto-title
            alt="유저 프로필"
            @click="downloadModalShown = true"
          ></CustomProfileImage>
          <figcaption @click="downloadModalShown = true">
            {{ feed.author.nickname }}
          </figcaption>
        </figure>
        <NuxtLink
          class="un_feedList_gathering"
          :to="`/gathering/${feed.gatheringInfo.id}`"
        >
          <CustomImage
            :src="feed.gatheringInfo.image"
            alt="모임 이미지"
          ></CustomImage>
          <!-- <img :src="feed.gatheringInfo.image" v-auto-title alt="모임 이미지" /> -->
          <dl>
            <dt>{{ feed.gatheringInfo.title }}</dt>
            <dd>{{ feed.gatheringInfo.region }}</dd>
          </dl>
        </NuxtLink>
        <p>
          {{ feed.description }}
        </p>
      </div>
      <div class="un_feedCarouselWrapper">
        <section class="un_feedCarousel">
          <div
            class="un_feedCarousel_inner"
            ref="sectionFeedCarousel"
            @touchstart="onTouchCarousel('start', $event)"
            @touchmove="onTouchCarousel('move', $event)"
            @touchend="onTouchCarousel('end', $event)"
            @touchcancel="onTouchCarousel('cancel', $event)"
          >
            <img
              v-for="(image, index) in feed.images"
              :key="index"
              :src="image"
              v-auto-title
              alt="피드 이미지"
            />
          </div>
          <div class="un_feedCarousel_btnWRapper">
            <button @click="addImageIndex(-1)"></button>
            <button @click="addImageIndex(+1)"></button>
          </div>
        </section>
        <div class="un_feedCarousel_indicator">
          <!-- .on 추가시 활성화 -->
          <i
            v-for="(_, index) in feed.images"
            :class="index === imageIndex ? 'on' : ''"
          ></i>
        </div>
      </div>
      <div class="bl_reactionSection">
        <i class="bl_reaction __chat" @click="downloadModalShown = true">{{
          feed.commentInfo.count
        }}</i>
        <i class="bl_reaction __heart" @click="downloadModalShown = true">{{
          feed.likeInfo.count
        }}</i>
      </div>
    </section>

    <section class="bl_commentSection" v-show="feed.commentInfo.count > 0">
      <h2 class="bl_commentSection_ttl">
        <strong>댓글</strong> {{ feed.commentInfo.count }}
      </h2>
      <div
        class="bl_commentSection_item"
        v-for="(comment, index) in feed.commentInfo.list"
        :key="index"
      >
        <figure class="el_profile hp_mb8">
          <!-- <img
            :src="comment.author.getImage"
            v-auto-title alt="유저 프로필"
            @click="downloadModalShown = true"
          /> -->
          <CustomProfileImage
            :src="comment.author.image"
            v-auto-title
            alt="유저 프로필"
            @click="downloadModalShown = true"
          ></CustomProfileImage>
          <figcaption @click="downloadModalShown = true">
            {{ comment.author.nickname }}
          </figcaption>
        </figure>
        <p>
          {{ comment.description }}
        </p>
        <div class="bl_reactionSection">
          <i class="bl_reaction __chat" @click="downloadModalShown = true">{{
            comment.recommentInfo.count
          }}</i>
          <i class="bl_reaction __heart" @click="downloadModalShown = true">{{
            comment.likeInfo.count
          }}</i>
        </div>
        <button
          v-show="comment.recommentInfo.count > 0"
          class="bl_commentSection_reply"
          @click="downloadModalShown = true"
        >
          댓글 {{ comment.recommentInfo.count }}개
        </button>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useGetStoreLink } from "~/composable/useGetStoreLink";
import api from "../../../utils/api";
import type GatheringFeedDetailPublic from "./gathering-feed-detail-public.dto";

const feedId = Number(useRoute().params.id);
if (!Number.isInteger(feedId)) {
  throw new Error("잘못된 접근입니다.");
}

const isClient = useNuxtApp().ssrContext === undefined;

const downloadModalShown = ref(false);

const sectionFeedCarousel = ref<HTMLElement>(null as any);

const feed = ref<GatheringFeedDetailPublic>(null as any);

const _asyncData = await useAsyncData("getGatheringFeedDetail", async () => {
  const { result, value } = await api.getGatheringFeedDetail(feedId);
  return { result, value };
});
if (_asyncData.data.value) {
  feed.value = _asyncData.data.value.value;
}
const truncateString = (str: string, maxLength: number) => {
  if (str.length > maxLength) {
    return str.slice(0, maxLength) + "...";
  }
  return str;
};

useHead({
  title:
    feed.value.description?.length > 0
      ? truncateString(feed.value.description, 35) + " | 오이 소통공간"
      : feed.value.gatheringInfo.title + " | 오이 소통공간",
  meta: [
    { name: "description", content: feed.value.description },
    { property: "og:title", content: "모임 커뮤니티 - 오이" },
    { property: "og:description", content: feed.value.description },
    {
      property: "og:image",
      content: feed.value.images[0] || "https://oe-app.com/images/og-image.png",
    },
  ],
  link: [
    { rel: "canonical", href: `https://oe-app.com/gathering/feed/${feedId}` },
  ],
});

const imageIndex = ref(0);

const addImageIndex = (value: number) => {
  imageIndex.value = Math.max(
    0,
    Math.min(feed.value.images.length - 1, imageIndex.value + value)
  );
  sectionFeedCarousel.value.style.transition = "transform 0.4s ease-in-out";
  const width = sectionFeedCarousel.value.getBoundingClientRect().width;
  const x = imageIndex.value * width;
  sectionFeedCarousel.value.style.transform = `translateX(-${x}px)`;
};

const goTo = (path: string) => {
  useRouter().push(path);
};

const storeLink = computed(() => {
  return useGetStoreLink(
    deeplink.gatheringFeedDetail(feed.value.gatheringInfo.id, feedId)
  );
});

let startX = 0;
let startTimestamp = 0;
const onTouchCarousel = (type: string, e: Event) => {
  if (type === "start") {
    startX = (e as TouchEvent).touches[0].clientX;
    startTimestamp = Date.now();
  } else if (type === "end") {
    const endX = (e as TouchEvent).changedTouches[0].clientX;
    const diffX = startX - endX;
    const diffTime = Date.now() - startTimestamp;
    if (diffTime < 300 && Math.abs(diffX) > 50) {
      if (diffX > 0) {
        onImageSwipe("left");
      } else {
        onImageSwipe("right");
      }
    }
  }
};

const onImageSwipe = (direction: "left" | "right") => {
  const userAgent = navigator.userAgent || navigator.vendor;
  const isMobile = /android|iPad|iPhone|iPod/i.test(userAgent);
  if (!isMobile) {
    return;
  }
  if (direction === "left") {
    addImageIndex(+1);
  } else if (direction === "right") {
    addImageIndex(-1);
  }
};
</script>

<style scoped>
@import "@/assets/css/seo.css";
@import "@/assets/css/base.css";
</style>
